import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: "16px 0 12px 0",
    "&::before": {
      content: "''",
      position: "absolute",
      top: 0,
      left: -24,
      right: -24,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
    "&:last-child::after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: -24,
      right: -24,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      padding: "20px 0",
    },
  },
  top: {
    flex: 1,
    display: "flex",
  },
  check: {
    width: 32,
  },
  main: {
    flex: 1,
    paddingRight: 0,
    "& a, & button": {
      textAlign: "left" as const,
      display: "inline",
      maxHeight: "20px",
      position: "absolute",
      width: "90%",
    },
    [theme.breakpoints.up("md")]: {
      paddingRight: 40,
      "& a, & button": {
        textAlign: "left" as const,
        display: "block",
        width: "100%",
        position: "unset",
      },
    },
  },
  name: {
    display: "inline-block",
    verticalAlign: "bottom",
    maxWidth: 300,
  },
  details: {
    flex: "0 0 44%",
  },
  detailsButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: 8,
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.primary.main,
    },
  },
  more: {
    flex: "0 0 24px",
    position: "relative",
  },
  moreButton: {
    width: 24,
    height: 24,
    padding: 0,
    border: "none",
    [theme.breakpoints.up("md")]: {
      border: `1px solid ${theme.palette.grey[300]}`,
    },
    borderRadius: 4,
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.grey[700],
      [theme.breakpoints.up("md")]: {
        color: theme.palette.grey[500],
      },
    },
    "&:disabled": {
      opacity: 0.4,
    },
  },
  bottom: {
    position: "relative",
    paddingTop: 16,
    paddingLeft: 32,
  },
}));
